// LICENSE PROTECTED SOFTWARE
import React from 'react';
import { Link } from 'react-router-dom';
import { Cookie, ArrowLeft } from 'lucide-react';

export default function CookiePolicyPage() {
  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-12">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-slate-900 mb-6" data-testid="back-home-link">
          <ArrowLeft className="w-4 h-4" /> Ana Sayfa
        </Link>
        <div className="flex items-center gap-3 mb-6">
          <Cookie className="w-8 h-8 text-amber-500" />
          <h1 className="text-3xl font-semibold text-slate-900">Çerez Politikası</h1>
        </div>
        <p className="text-sm text-slate-500 mb-8">Son güncelleme: {new Date().toLocaleDateString('tr-TR')}</p>

        <div className="prose prose-slate max-w-none space-y-6 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-0">1. Çerez Nedir?</h2>
            <p>Çerezler, web sitesini ziyaret ettiğinizde tarayıcınız tarafından cihazınıza kaydedilen küçük metin dosyalarıdır. Bu siteye giriş yapan kullanıcıların oturumunu sürdürmek ve güvenliği sağlamak için kullanılırlar.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900">2. Kullandığımız Çerezler</h2>
            <table className="w-full text-sm border border-slate-200 rounded-lg overflow-hidden">
              <thead className="bg-slate-100">
                <tr><th className="p-3 text-left">Çerez</th><th className="p-3 text-left">Amaç</th><th className="p-3 text-left">Süre</th><th className="p-3 text-left">Tür</th></tr>
              </thead>
              <tbody className="divide-y divide-slate-200">
                <tr><td className="p-3 font-mono text-xs">access_token</td><td className="p-3">Oturum kimlik doğrulaması (HttpOnly)</td><td className="p-3">15 dk</td><td className="p-3">Zorunlu</td></tr>
                <tr><td className="p-3 font-mono text-xs">refresh_token</td><td className="p-3">Oturum yenileme (HttpOnly, döngüsel)</td><td className="p-3">7 gün</td><td className="p-3">Zorunlu</td></tr>
                <tr><td className="p-3 font-mono text-xs">csrf_token</td><td className="p-3">CSRF saldırı koruması</td><td className="p-3">24 saat</td><td className="p-3">Zorunlu</td></tr>
                <tr><td className="p-3 font-mono text-xs">cookie_consent</td><td className="p-3">Çerez tercihinizin saklanması (localStorage)</td><td className="p-3">1 yıl</td><td className="p-3">Zorunlu</td></tr>
              </tbody>
            </table>
            <p className="text-sm text-slate-500 mt-3">Bu sitede analitik, reklam veya üçüncü taraf takip çerezleri <strong>kullanılmamaktadır</strong>.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900">3. Tercihlerinizi Yönetme</h2>
            <p>Tarayıcı ayarlarınızdan çerezleri silebilir veya engelleyebilirsiniz. Ancak oturum çerezlerini devre dışı bırakırsanız platforma giriş yapamazsınız.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900">4. İletişim</h2>
            <p>Çerez politikamızla ilgili sorularınız için <Link to="/iletisim" className="text-blue-600 hover:underline">iletişim sayfamızı</Link> kullanabilirsiniz.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
